export class StorageUnavailableError extends Error {
  readonly cause?: unknown;

  constructor(message: string, cause?: unknown) {
    super(message);
    this.name = 'StorageUnavailableError';
    this.cause = cause;
  }
}

export class CorruptRecordError extends Error {
  readonly recordId: string;
  readonly recordType: string;

  constructor(recordType: string, recordId: string, message: string) {
    super(message);
    this.name = 'CorruptRecordError';
    this.recordType = recordType;
    this.recordId = recordId;
  }
}

export function storageFailureMessage(error: unknown): string {
  if (error instanceof StorageUnavailableError) {
    return error.message;
  }
  if (error instanceof Error && error.name === 'QuotaExceededError') {
    return 'Local storage is full. Export a backup, then delete old saved games.';
  }
  return 'Saved games are temporarily unavailable. Your current session is still active on this page.';
}
